import { render, staticRenderFns } from "./BarCharts.vue?vue&type=template&id=c9ffb840"
import script from "./BarCharts.vue?vue&type=script&lang=js"
export * from "./BarCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports